import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  private httpHeadersDefault: HttpHeaders;

  constructor(private http: HttpClient) {
    this.httpHeadersDefault = new HttpHeaders().set('Content-type', 'application/json');;

  }

  addSocio(socio: any): Observable<any> {
    const options = { headers: this.httpHeadersDefault };
    return this.http.post<any>('/api/dolomitiuser/add-socio-nuovo', socio, options);
  }
}
